import React, { useContext, useState } from 'react';
import { Typography } from '@mui/material';
import { StyledSidebarContent, StyledSidebarList } from './Sidebar.styles';
import SidebarItem from './SidebarItem';

import DashboardIcon from '../../../../public/images/sidebar/dashboard_icon.png';
import HomeIcon from '../../../../public/images/sidebar/home.png';
import ScholarshipIcon from '../../../../public/images/sidebar/scholarship.png';
import AdminIcon from '../../../../public/images/sidebar/admin.png';
import HistoryIcon from '../../../../public/images/sidebar/history_icon.png';
import RomaniaIcon from '../../../../public/images/sidebar/romania_icon.png';
import LawIcon from '../../../../public/images/sidebar/law_icon.png';
import EnglishIcon from '../../../../public/images/sidebar/english_icon.png';
import CommunityIcon from '../../../../public/images/sidebar/community_icon.png';
import FranceIcon from '../../../../public/images/sidebar/france.webp';
import LogicIcon from '../../../../public/images/sidebar/logic_icon.png';
import HelpIcon from '../../../../public/images/sidebar/help.svg';
import BlogIcon from '../../../../public/images/sidebar/blog.webp';
import TeacherIcon from '../../../../public/images/sidebar/teacher.webp';
import BadgeIcon from '../../../../public/images/sidebar/badge.webp';
import RankIcon from '../../../../public/images/sidebar/rank_icon.webp';
import useUser from '../../../../hooks/useUser';
import { rules } from '../../../Auth/PriorityRules';

const menuSections = {
	General: [
		{ id: 1, title: 'Acasă', icon: HomeIcon, path: '/' },
		{ id: 2, title: 'Performanțele tale', icon: DashboardIcon, path: '/statistici' }
	],
	'Zonă profesor': [{ id: 3, title: 'Panou Profesor', icon: TeacherIcon, path: '/profesor' }],
	'ADMITERE M.A.I.': [
		{
			id: 4,
			title: 'Lb. Română',
			icon: RomaniaIcon,
			subItems: [
				{ id: '4-1', title: 'Teste grilă', path: '/romana/test' },
				{ id: '4-2', title: 'Mod Interactiv', path: '/romana/mod-interactiv' },
				{ id: '4-4', title: 'Sinteze', path: '/romana/materie' }
			]
		},
		{
			id: 5,
			title: 'Istorie',
			icon: HistoryIcon,
			subItems: [
				{ id: '5-1', title: 'Teste grilă', path: '/istorie/test' },
				{ id: '5-2', title: 'Mod Interactiv', path: '/istorie/mod-interactiv' },
				{ id: '5-4', title: 'Sinteze', path: '/istorie/materie' }
			]
		},
		{
			id: 6,
			title: 'Lb. Engleză',
			icon: EnglishIcon,
			subItems: [
				{ id: '6-1', title: 'Teste grilă', path: '/engleza/test' },
				{ id: '6-2', title: 'Mod Interactiv', path: '/engleza/mod-interactiv' },
				{ id: '6-4', title: 'Sinteze', path: '/engleza/materie' }
			]
		},
		{
			id: 7,
			title: 'Lb. Franceză',
			icon: FranceIcon,
			subItems: [
				{ id: '7-1', title: 'Teste grilă', path: '/franceza/test' },
				{ id: '7-2', title: 'Mod Interactiv', path: '/franceza/mod-interactiv' }
			]
		},
		{
			id: 8,
			title: 'Legislație',
			icon: LawIcon,
			subItems: [
				{ id: '8-1', title: 'Teste grilă', path: '/legislatie/test' },
				{ id: '8-2', title: 'Mod Interactiv', path: '/legislatie/mod-interactiv' },
				{ id: '8-3', title: 'Sinteze', path: '/legislatie/materie' },
				{ id: '8-4', title: 'Sinteze (Admin)', path: '/legislatie/materie/admin' }
			]
		},
		{
			id: 9,
			title: 'Educație civică',
			icon: CommunityIcon,
			subItems: [
				{ id: '9-1', title: 'Teste grilă', path: '/civica/test' },
				{ id: '9-2', title: 'Mod Interactiv', path: '/civica/mod-interactiv' },
				{ id: '9-3', title: 'Sinteze', path: '/civica/materie' },
				{ id: '9-4', title: 'Sinteze (Admin)', path: '/civica/materie/admin' }
			]
		},
		{
			id: 10,
			title: 'Logică',
			icon: LogicIcon,
			subItems: [
				{ id: '10-1', title: 'Teste grilă', path: '/logica/test' },
				{ id: '10-2', title: 'Mod Interactiv', path: '/logica/mod-interactiv' },
				{ id: '10-3', title: 'Sinteze', path: '/logica/materie' },
				{ id: '10-4', title: 'Sinteze (Admin)', path: '/logica/materie/admin' }
			]
		}
	],
	Clasament: [{ id: 11, title: 'Clasament', icon: RankIcon, path: '/clasament/rezultate-tara' }],
	Simulare: [{ id: 12, title: 'Generează simulare', icon: ScholarshipIcon, path: '/simulare' }],
	'ALTE CONCURSURI': [
		{
			id: 13,
			title: 'Sursă externă/TCO',
			icon: BadgeIcon,
			subItems: [
				{ id: '13-1', title: 'Teste grilă', path: '/tco/test' },
				{ id: '13-2', title: 'Materiale', path: '/tco/materie' },
				{ id: '13-3', title: 'Materiale (Admin)', path: '/tco/materie/admin' }
			]
		}
	],
	Utile: [
		{ id: 14, title: 'Blog', icon: BlogIcon, path: 'https://admiterepolitie.ro/blog' },
		{ id: 15, title: 'Ajutor', icon: HelpIcon, path: '/tichete' }
	],
	Administrator: [
		{
			id: 16,
			title: 'Admin',
			icon: AdminIcon,
			subItems: [
				{ id: '16-1', title: 'Examene', path: '/admin/exams' },
				{ id: '16-2', title: 'Grile', path: '/admin/grile' },
				{ id: '16-3', title: 'Utilizatori', path: '/admin/users' },
				{ id: '16-4', title: 'Grile Raportate', path: '/admin/raportari/grile' },
				{ id: '16-5', title: 'Tichete', path: '/admin/raportari/platforma' }
			]
		}
	]
};

const SidebarContent = ({ onMobileItemClick }) => {
	const [openItemId, setOpenItemId] = useState(null); // Track open sidebar item by ID
	const { user } = useUser();
	const userRole = user?.Role ?? null; // Default to Student if undefined
	const allowedPaths = rules[userRole]?.allowed_paths || [];

	// Filter sections dynamically based on allowed paths
	const filteredSections = Object.entries(menuSections).reduce((acc, [sectionTitle, items]) => {
		const filteredItems = items
			.map((item) => {
				if (item.subItems) {
					const filteredSubItems = item.subItems.filter((subItem) =>
						allowedPaths.includes(subItem.path)
					);
					return filteredSubItems.length ? { ...item, subItems: filteredSubItems } : null;
				}
				return allowedPaths.includes(item.path) ? item : null;
			})
			.filter(Boolean); // Remove null items

		if (filteredItems.length > 0) {
			acc[sectionTitle] = filteredItems;
		}
		return acc;
	}, {});

	return (
		<StyledSidebarContent>
			<StyledSidebarList>
				{Object.entries(filteredSections).map(([sectionTitle, items]) => (
					<React.Fragment key={sectionTitle}>
						<Typography
							sx={{
								fontSize: '0.75rem',
								fontWeight: 'bold',
								color: '#666',
								margin: '16px 0 8px 0',
								textTransform: 'uppercase'
							}}
						>
							{sectionTitle}
						</Typography>
						{items.map((item) => (
							<SidebarItem
								key={item.id}
								item={item}
								openItemId={openItemId}
								setOpenItemId={setOpenItemId}
								onMobileItemClick={onMobileItemClick}
							/>
						))}
					</React.Fragment>
				))}
			</StyledSidebarList>
		</StyledSidebarContent>
	);
};

export default SidebarContent;
